export default __webpack_public_path__ + "static/35709de9d918ac6a270dce25925b26fb.png";